export default __webpack_public_path__ + "static/media/MeditationIllustration.d3c77f6c.svg";